/* @flow */

import React from 'react';

type Props = {
  message?: string,
};

const PageLoader = ({ message = 'Chargement...' }: Props) => (
  <div className="ui active page dimmer">
    <div className="content">
      <div className="ui large text loader">{message}</div>
    </div>
  </div>
);

export default PageLoader;



// WEBPACK FOOTER //
// ./src/shared/components/PageLoader.js